// For Loading
export const TOGGLE_LOADING = 'TOGGLE_LOADING';


export const FETCH_HISTORY_CHAT_LISTING = 'FETCH_HISTORY_CHAT_LISTING';


export const FETCH_MAIN_CHAT_LISTING = 'FETCH_MAIN_CHAT_LISTING';


export const AMA_TOGGLE_LOADING = 'AMA_TOGGLE_LOADING';

export const FETCH_CANNED_DOCS = 'FETCH_CANNED_DOCS';
  